import { render, staticRenderFns } from "./SpaceUserManagement.vue?vue&type=template&id=681557af&"
import script from "./SpaceUserManagement.vue?vue&type=script&lang=js&"
export * from "./SpaceUserManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports